<template>
  <div>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      CLIMA LARGO PLAZO
    </p>
    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text">Clima Largo Plazo</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn color="secondary" @click="irAddDataClima"
          >Agregar Información Ubicación</v-btn
        >

        <!-- <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-apps</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>-->
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row></v-row>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >
    <v-overlay :value="loadingScreen">
      <v-progress-circular
        class="mb-4"
        indeterminate
        size="64"
      ></v-progress-circular>
      <p>Cargando...</p>
    </v-overlay>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "Clima",
  data() {
    return {
      rules: [(v) => !!v || "Este campo es requerido"],
      rulesMultiple: [
        (v) => {
          if (!v || v.length < 1) {
            return "Este campo es requerido";
          } else {
            return true;
          }
        },
      ],
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loadingScreen: false,
    };
  },
  mounted() {},
  methods: {
    irAddDataClima() {
      this.$router.push(`/admin/clima/largo-plazo/upload-data`);
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>
